let bcrypt = require('bcryptjs')

const USER_ROLE_SUPER       = 'Super'
const USER_ROLE_ADMIN       = 'Admin'
const USER_ROLE_MODERATOR   = 'Moderator'
const USER_ROLE_USER        = 'User'

const USER_ROLES = [ USER_ROLE_SUPER, USER_ROLE_ADMIN, USER_ROLE_MODERATOR, USER_ROLE_USER ]

const SUPERADMIN_DEFAULT_HASH = bcrypt.hashSync("1234567890")

const CATEGORIES_ADMIN = [  
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'en'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'en'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'en'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'en'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'en'},
  { name: 'Anuncios', color: 'rgb(166, 207, 237)', lang: 'es'},
  { name: 'Bugs/sugerencias', color: 'rgb(166, 207, 237)', lang: 'es'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'es'},
  { name: 'Ayuda', color: 'rgb(166, 207, 237)', lang: 'es'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'es'},
  { name: 'Annonces', color: 'rgb(166, 207, 237)', lang: 'fr'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'fr'},
  { name: 'Général', color: 'rgb(166, 207, 237)', lang: 'fr'},
  { name: 'Aide', color: 'rgb(166, 207, 237)', lang: 'fr'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'fr'},
  { name: 'Annunci', color: 'rgb(166, 207, 237)', lang: 'it'},
  { name: 'Bug/consigli', color: 'rgb(166, 207, 237)', lang: 'it'},
  { name: 'Generale', color: 'rgb(166, 207, 237)', lang: 'it'},
  { name: 'Aiuto', color: 'rgb(166, 207, 237)', lang: 'it'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'it'},
  { name: 'Ankündigungen', color: 'rgb(166, 207, 237)', lang: 'de'},
  { name: 'Fehler/Vorschläge', color: 'rgb(166, 207, 237)', lang: 'de'},
  { name: 'Allgemein', color: 'rgb(166, 207, 237)', lang: 'de'},
  { name: 'Hilfe', color: 'rgb(166, 207, 237)', lang: 'de'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'de'},
  { name: 'Ogłoszenia', color: 'rgb(166, 207, 237)', lang: 'pl'},
  { name: 'Błędy/sugestie', color: 'rgb(166, 207, 237)', lang: 'pl'},
  { name: 'Ogólne', color: 'rgb(166, 207, 237)', lang: 'pl'},
  { name: 'Pomoc', color: 'rgb(166, 207, 237)', lang: 'pl'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'pl'},
  { name: 'Reklamlar', color: 'rgb(166, 207, 237)', lang: 'tr'},
  { name: 'Hatalar/öneriler', color: 'rgb(166, 207, 237)', lang: 'tr'},
  { name: 'Genel', color: 'rgb(166, 207, 237)', lang: 'tr'},
  { name: 'Yardım', color: 'rgb(166, 207, 237)', lang: 'tr'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'tr'},
  { name: 'Анонсы', color: 'rgb(166, 207, 237)', lang: 'ru'},
  { name: 'Ошибки / предложения', color: 'rgb(166, 207, 237)', lang: 'ru'},
  { name: 'Общее', color: 'rgb(166, 207, 237)', lang: 'ru'},
  { name: 'Помощь', color: 'rgb(166, 207, 237)', lang: 'ru'},
  { name: 'Не по теме', color: 'rgb(166, 207, 237)', lang: 'ru'},
  { name: 'Anunțuri', color: 'rgb(166, 207, 237)', lang: 'ro'},
  { name: 'Bug-uri/Sugestii', color: 'rgb(166, 207, 237)', lang: 'ro'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'ro'},
  { name: 'Ajutor', color: 'rgb(166, 207, 237)', lang: 'ro'},
  { name: 'Despre subiect', color: 'rgb(166, 207, 237)', lang: 'ro'},
  { name: 'Oznámení', color: 'rgb(166, 207, 237)', lang: 'cs'},
  { name: 'Chyby/návrhy', color: 'rgb(166, 207, 237)', lang: 'cs'},
  { name: 'Obecné', color: 'rgb(166, 207, 237)', lang: 'cs'},
  { name: 'Nápověda', color: 'rgb(166, 207, 237)', lang: 'cs'},
  { name: 'Mimo téma', color: 'rgb(166, 207, 237)', lang: 'cs'},
  { name: 'Anúncios', color: 'rgb(166, 207, 237)', lang: 'pt'},
  { name: 'Bugs/sugestões', color: 'rgb(166, 207, 237)', lang: 'pt'},
  { name: 'Geral', color: 'rgb(166, 207, 237)', lang: 'pt'},
  { name: 'Ajuda', color: 'rgb(166, 207, 237)', lang: 'pt'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'pt'},
  { name: 'Ανακοινώσεις', color: 'rgb(166, 207, 237)', lang: 'el'},
  { name: 'Σφάλματα/προτάσεις', color: 'rgb(166, 207, 237)', lang: 'el'},
  { name: 'Γενικά', color: 'rgb(166, 207, 237)', lang: 'el'},
  { name: 'Βοήθεια', color: 'rgb(166, 207, 237)', lang: 'el'},
  { name: 'Εκτός θέματος', color: 'rgb(166, 207, 237)', lang: 'el'},
  { name: '公告', color: 'rgb(166, 207, 237)', lang: 'zh'},
  { name: '错误/建议', color: 'rgb(166, 207, 237)', lang: 'zh'},
  { name: '全体', color: 'rgb(166, 207, 237)', lang: 'zh'},
  { name: '帮助', color: 'rgb(166, 207, 237)', lang: 'zh'},
  { name: '离题', color: 'rgb(166, 207, 237)', lang: 'zh'},
  { name: 'Kunngjøringer', color: 'rgb(166, 207, 237)', lang: 'no'},
  { name: 'Feil/forslag', color: 'rgb(166, 207, 237)', lang: 'no'},
  { name: 'Generelt', color: 'rgb(166, 207, 237)', lang: 'no'},
  { name: 'Hjelp', color: 'rgb(166, 207, 237)', lang: 'no'},
  { name: 'Av tema', color: 'rgb(166, 207, 237)', lang: 'no'},
  { name: 'Meddelanden', color: 'rgb(166, 207, 237)', lang: 'sv'},
  { name: 'Fel/förslag', color: 'rgb(166, 207, 237)', lang: 'sv'},
  { name: 'Allmänt', color: 'rgb(166, 207, 237)', lang: 'sv'},
  { name: 'Hjälp', color: 'rgb(166, 207, 237)', lang: 'sv'},
  { name: 'Inte aktuellt', color: 'rgb(166, 207, 237)', lang: 'sv'},
  { name: 'Оголошення', color: 'rgb(166, 207, 237)', lang: 'uk'},
  { name: 'Помилки/пропозиції', color: 'rgb(166, 207, 237)', lang: 'uk'},
  { name: 'Загальні', color: 'rgb(166, 207, 237)', lang: 'uk'},
  { name: 'Довідка', color: 'rgb(166, 207, 237)', lang: 'uk'},
  { name: 'Не по темі', color: 'rgb(166, 207, 237)', lang: 'uk'},
  { name: 'Meddelelser', color: 'rgb(166, 207, 237)', lang: 'da'},
  { name: 'Fejl/forslag', color: 'rgb(166, 207, 237)', lang: 'da'},
  { name: 'Generel', color: 'rgb(166, 207, 237)', lang: 'da'},
  { name: 'Hjælp', color: 'rgb(166, 207, 237)', lang: 'da'},
  { name: 'Udenfor emne', color: 'rgb(166, 207, 237)', lang: 'da'},
  { name: 'Aankondigingen', color: 'rgb(166, 207, 237)', lang: 'nl'},
  { name: 'Bugs/suggesties', color: 'rgb(166, 207, 237)', lang: 'nl'},
  { name: 'Algemeen', color: 'rgb(166, 207, 237)', lang: 'nl'},
  { name: 'Hulp', color: 'rgb(166, 207, 237)', lang: 'nl'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'nl'},
  { name: 'Ilmoitukset', color: 'rgb(166, 207, 237)', lang: 'fi'},
  { name: 'Bugit/ehdotukset', color: 'rgb(166, 207, 237)', lang: 'fi'},
  { name: 'Yleistä', color: 'rgb(166, 207, 237)', lang: 'fi'},
  { name: 'Apua', color: 'rgb(166, 207, 237)', lang: 'fi'},
  { name: 'Aiheen vierestä', color: 'rgb(166, 207, 237)', lang: 'fi'},
  { name: 'Najave', color: 'rgb(166, 207, 237)', lang: 'bs'},
  { name: 'Greške/prijedlozi', color: 'rgb(166, 207, 237)', lang: 'bs'},
  { name: 'Općenito', color: 'rgb(166, 207, 237)', lang: 'bs'},
  { name: 'Pomoć', color: 'rgb(166, 207, 237)', lang: 'bs'},
  { name: 'Van teme', color: 'rgb(166, 207, 237)', lang: 'bs'},
  { name: 'Najave', color: 'rgb(166, 207, 237)', lang: 'hr'},
  { name: 'Greške/prijedlozi', color: 'rgb(166, 207, 237)', lang: 'hr'},
  { name: 'Općenito', color: 'rgb(166, 207, 237)', lang: 'hr'},
  { name: 'Pomoć', color: 'rgb(166, 207, 237)', lang: 'hr'},
  { name: 'Van teme', color: 'rgb(166, 207, 237)', lang: 'hr'},
  { name: 'Najave', color: 'rgb(166, 207, 237)', lang: 'sr'},
  { name: 'Greške/predlozi', color: 'rgb(166, 207, 237)', lang: 'sr'},
  { name: 'Osnovno', color: 'rgb(166, 207, 237)', lang: 'sr'},
  { name: 'Pomoć', color: 'rgb(166, 207, 237)', lang: 'sr'},
  { name: 'Van teme', color: 'rgb(166, 207, 237)', lang: 'sr'},
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'ko'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'ko'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'ko'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'ko'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'ko'},
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'ja'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'ja'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'ja'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'ja'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'ja'},
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'vi'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'vi'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'vi'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'vi'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'vi'},
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'ar'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'ar'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'ar'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'ar'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'ar'},
  { name: 'Announcements', color: 'rgb(166, 207, 237)', lang: 'th'},
  { name: 'Bugs/suggestions', color: 'rgb(166, 207, 237)', lang: 'th'},
  { name: 'General', color: 'rgb(166, 207, 237)', lang: 'th'},
  { name: 'Help', color: 'rgb(166, 207, 237)', lang: 'th'},
  { name: 'Off-topic', color: 'rgb(166, 207, 237)', lang: 'th'},
]

const CATEGORY_ALL = {
  "en": {
    "url": "all",
    "title": "All"
  },
  "es": {
    "url": "todo",
    "title": "Todo"
  },
  "fr": {
    "url": "tout",
    "title": "Tout"
  },
  "it": {
    "url": "tutto",
    "title": "Tutto"
  },
  "de": {
    "url": "alles",
    "title": "Alles"
  },
  "pl": {
    "url": "wszystko",
    "title": "Wszystko"
  },
  "tr": {
    "url": "hepsi",
    "title": "Hepsi"
  },
  "ru": {
    "url": "%D0%B2%D1%81%D0%B5",
    "title": "Все"
  },
  "ro": {
    "url": "tot",
    "title": "Tot"
  },
  "cs": {
    "url": "vse",
    "title": "Vše"
  },
  "pt": {
    "url": "tudo",
    "title": "Tudo"
  },
  "el": {
    "url": "%CE%BF%CE%BB%CE%B1",
    "title": "Ολα"
  },
  "th": {
    "url": "%E0%B8%97%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%AB%E0%B8%A1%E0%B8%94",
    "title": "ทั้งหมด"
  },
  "zh": {
    "url": "%E5%85%A8%E9%83%A8%E7%9A%84",
    "title": "全部的"
  },
  "no": {
    "url": "alle",
    "title": "Alle"
  },
  "sv": {
    "url": "alla",
    "title": "Alla"
  },
  "uk": {
    "url": "%D0%B2%D1%81%D1%96",
    "title": "Всі"
  },
  "da": {
    "url": "alle",
    "title": "Alle"
  },
  "nl": {
    "url": "alles",
    "title": "Alles"
  },
  "fi": {
    "url": "kaikki",
    "title": "Kaikki"
  },
  "bs": {
    "url": "sve",
    "title": "Sve"
  },
  "hr": {
    "url": "sve",
    "title": "Sve"
  },
  "sr": {
    "url": "sve",
    "title": "Sve"
  },
  "ko": {
    "url": "all",
    "title": "All"
  },
  "ja": {
    "url": "all",
    "title": "All"
  },
  "vi": {
    "url": "all",
    "title": "All"
  },
  "ar": {
    "url": "all",
    "title": "All"
  }
}

const URL_JSON_TRANSLATION = "https://en.idcgames.com/idcjson/forum_translation.json"

module.exports = {
  USER_ROLES, USER_ROLE_SUPER, USER_ROLE_ADMIN, USER_ROLE_MODERATOR, USER_ROLE_USER,
  SUPERADMIN_DEFAULT_HASH,
  CATEGORIES_ADMIN,
  CATEGORY_ALL,
  URL_JSON_TRANSLATION
}